import { render, staticRenderFns } from "./UidTesting.vue?vue&type=template&id=04db4bf2&scoped=true"
import script from "./UidTesting.vue?vue&type=script&lang=js"
export * from "./UidTesting.vue?vue&type=script&lang=js"
import style0 from "./UidTesting.vue?vue&type=style&index=0&id=04db4bf2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04db4bf2",
  null
  
)

export default component.exports